import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import MainNavbar from './components/MainNavbar/MainNavbar';
import EnglishSection from './components/EnglishSection/EnglishSection';
import Portfolio from './components/Portfolio/Portfolio';
import Stories from './components/Stories/Stories';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import ScrollButton from './components/Portfolio/components/ScrollButton/ScrollButton';
import { LanguageProvider } from './hooks/useLanguage';

const AppContent = () => {
  const location = useLocation();
  const isEnglishSection = location.pathname === '/english';

  return (
    <div className="App">
      <MainNavbar />
      <main className="app-main">
        <Routes>
          {/* Ruta raíz redirige a portfolio */}
          <Route path="/" element={<Navigate to="/portfolio" replace />} />
          
          {/* Ruta protegida para English */}
          <Route 
            path="/english" 
            element={
              <ProtectedRoute>
                <EnglishSection />
              </ProtectedRoute>
            } 
          />
          
          {/* Ruta protegida para Stories */}
          <Route 
            path="/stories" 
            element={
              <ProtectedRoute>
                <Stories />
              </ProtectedRoute>
            } 
          />
          
          {/* Ruta pública para Portfolio */}
          <Route path="/portfolio" element={<Portfolio />} />
          
          {/* Ruta para About que redirige a portfolio con scroll */}
          <Route 
            path="/about" 
            element={<Portfolio scrollTo="about" />} 
          />
          
          {/* Ruta para Contact que redirige a portfolio con scroll */}
          <Route 
            path="/contact" 
            element={<Portfolio scrollTo="contact" />} 
          />
          
          {/* Ruta por defecto - redirige a portfolio */}
          <Route path="*" element={<Navigate to="/portfolio" replace />} />
        </Routes>
      </main>
      <ScrollButton showPracticeButton={isEnglishSection} />
    </div>
  );
};

const App = () => {
  return (
    <LanguageProvider>
      <Router>
        <AppContent />
      </Router>
    </LanguageProvider>
  );
};

export default App;
